/* 
 - TODO: Explanation
*/

import { DatabaseTable, returnID } from "../BaseTable";
import { types } from "../../helpers/Util";
import store from "../../store/Store";
import Interval from "./Interval";

class CommunicationSetRaw extends DatabaseTable {
  id: number;
  name: string | null;
  shared: boolean;
  modified: Date;

  static readonly serializableFields = new Map([
    ["id", [types.number]],
    ["name", [types.string, types.null]], 
    ["shared", [types.boolean]], 
    ["modified", [types.date, types.string]],
  ]);
  static readonly tableName = "CommunicationSet";

  constructor(id = -1, name = null, shared = false, modified = new Date()) {
    super();
    this.id = returnID(id);
    this.name = name;
    this.shared = shared;
    this.modified = modified;
  }
}

class CommunicationSet extends CommunicationSetRaw {
  constructor(...args: any[]) {
    super(...args);
  }

  onDelete() {
    const allIntervals = store.getState().tables.tables.get(Interval) as
      | undefined
      | Array<Interval>;
    const intervalsForThisCommSet = allIntervals?.filter(
      (interval: Interval) => {
        return interval.communication_set_id == this.id;
      },
    );

    // clear out comm_set_id from each interval
    intervalsForThisCommSet?.forEach((interval: Interval) => {
      interval.update("communication_set_id", null).save();
    });
  }
}

export default CommunicationSet;
